'use client'
import { useEffect } from 'react'
import { Raphael } from 'react-raphael'

import './mapdata.js'
import './usmap.js'

const BASE_URL = process.env.baseUrl

const buildLocationObject = (market: any) => {
  if (!market.center) {
    console.warn('market is missing center', market.market)
    return
  }
  return {
    lat: market.center ? market.center.coordinates[1] : 29.761,
    lng: market.center ? market.center.coordinates[0] : -95.37,
    name: market.market,
    color: '#F0DBD1',
    url: `${BASE_URL}/${market.marketPage.slug}/`,
    image_url: 'https://api.creatomate.com/v1/direct?template_id=ad008404-2a07-4181-8c7d-36484014d521&v=5&output_format=png&number=' + market.apartments.items.length,
    size: '30',
    type: 'image'
  }
}

export default function Map({ states, data }: { states: string[], data: any }) {
  let i = 0
  const locations = states.reduce((acc, next) => {
    const obj: any = {}
    for(const market of data[next]) {
      const location = buildLocationObject(market)
      if (location) {
        obj[`${i}`] = location
        i += 1
      }
    }

    return {
      ...acc,
      ...obj,
    }
  }, {})
  useEffect(() => {
    if (locations) {
      window.simplemaps_usmap_mapdata.locations = locations
    }
    window.Raphael = Raphael
    window.simplemaps_usmap.load()
  }, [])

  return <div id='map' />
}
